module.exports = __webpack_public_path__ + "img/人员招聘.cb3d38f6.jpg";